/* PinkSalt reviews strip for the HOMEPAGE and the two collection landers
 * (templates/index.json, collection.json, collection.salt-lamps.json).
 *
 * REBUILT 2026-09-10, owner off a screenshot: "reviews on the home page are not updated.
 * and they should look like attached image3". Two complaints in one sentence.
 *
 *  (a) NOT UPDATED. Nothing here is hardcoded: the cards and aggregate are fetched live
 *      from Judge.me. V2 widens the homepage source list to the full relevant catalog and
 *      can include historical reviews from products that are temporarily unavailable.
 *
 *  (b) WRONG DESIGN. The card is now the card the PRODUCT pages use: avatar disc carrying
 *      the reviewer's initial, name over date, a star row on its own line, the review, then
 *      the photographs at CARD WIDTH. This strip used to show no photographs at all.
 *
 * ---------------------------------------------------------------------------------------
 * THE CARD IS MIRRORED FROM sections/ps-reviews.liquid + assets/ps-reviews.js.
 * Those two are read by FOURTEEN product handles and are deliberately NOT touched by this
 * file. renderCard() below is a copy of renderCard() in assets/ps-reviews.js, and the card
 * CSS is copied into sections/ps-home-reviews.liquid scoped under `.ps-hrev` instead of
 * `.ps-reviews`. CHANGE ONE, CHANGE THE OTHER. Four deliberate divergences, each marked
 * DIVERGENCE at its site below:
 *   1. the review body is inserted as TEXT, never HTML (this file's long-standing rule);
 *   2. each photograph is a LINK to the product, not a lightbox button, because this strip
 *      has no lightbox and a button wired to nothing is a defect;
 *   3. review VIDEOS are not rendered here;
 *   4. the card carries an "on <product>" line the product card has no need for.
 * ---------------------------------------------------------------------------------------
 *
 * HONESTY RULES
 *  - NOTHING is fabricated. No rating, count, reviewer name, date or sentence is typed
 *    anywhere in this file or in the section. Every value comes from the Judge.me API.
 *  - Featured reviews are still verbatim Judge.me records. The homepage deliberately
 *    chooses one useful review per product, preferring customer photographs and text that
 *    answers common product-fit questions. Rating, reviewer, date and copy are never edited.
 *  - The aggregate is the API's OWN per-product total and average, weighted and summed, so
 *    it can never be inflated by which reviews the strip happens to show. See fetchProduct.
 *  - The band renders NOTHING until it has at least one real card. No skeletons, no empty
 *    chrome, no aggregate floating on its own above an empty list.
 *
 * WHY ONLY PAGE 1 PER PRODUCT (changed 2026-09-10)
 * This used to walk every page of every product so it could average the reviews it had
 * fetched. Widening the list to eight products would have made that about 25 cross-origin
 * requests on the homepage. It is now ONE request per product, because reviews_for_widget
 * returns `number_of_reviews` and `average_rating` for the whole product on page 1, which
 * is a better aggregate than a sample average, not a worse one. The cards are still exactly
 * right: page 1 is a product's 30 NEWEST reviews, and the globally newest N across all
 * products is always inside the union of the per-product newest 30 for any N <= 30, and
 * max_cards caps at 12. Net effect: 6 live requests where the old three-product list made 7.
 */
(function () {
  var ROOT_ID = 'ps-home-reviews';
  var MONTHS = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];

  // A featured card has to actually say something. The import is full of auto-translated
  // fragments ("Good product", "The order has been processed as well") and text-less
  // imports whose body just repeats the product title. Length is a blunt instrument, so
  // it is only ever a FLOOR for what may be featured, never the ranking.
  var MIN_FEATURE_BODY = 60;
  var FEATURE_TERMS = /better in person|well made|quality|texture|crystal|salt|glow|amber|light|night|bedroom|nightstand|desk|reading|routine|ritual|gift|size|diffus|mist|scent|oil|colour|color|portable|cordless|recharge/i;

  /* ---- claims gate (CLAUDE.md claims matrix) ----
   * Republished UGC is a claim the store makes. Kept character for character in step with
   * BANNED_CLAIM in assets/ps-reviews.js, so a review the PDP refuses cannot reach the
   * front page instead. Anchored so it cannot eat legitimate words: no bare "therap"
   * (keeps "Aromatherapy"), no bare "ion", and "heals\b" (not bare "heal") so a reviewer
   * named "Micheal" is never matched. Only title + body are tested, never the name. */
  var BANNED_CLAIM = /negative ions?|ionis|ioniz|air[^.]{0,14}purif|purif[^.]{0,14}air|air quality|clean[^.]{0,10}the air|detox|toxins?|cellulite|acne|asthma|allerg|respiratory|anxiety|insomnia|migraine|blood ?pressure|\bemf\b|therapeutic|antibacterial|antimicrobial|cures?\b|heals\b|healing/i;

  /* ---- delivery gate ----
   * Ported from HERO_NO_DELIVERY in assets/ps-reviews.js (owner 2026-09-10, "exclude quotes
   * mentioning delivery in hero section"). It applies here for the same reason it applies
   * there: this is a hand-sized SELECTION of three reviews on the first screen a cold
   * visitor sees, not the full band, and on a store promising 12 to 15 days a featured
   * review must not make a delivery promise in EITHER direction. The complaint that
   * prompted the rule opened "It took quite a while to arrive"; two of the others praised
   * the speed, which is just as much a promise. Both go. The PDP band still shows all. */
  var NO_DELIVERY = /\b(deliver\w*|ship\w*|arriv\w*|courier\w*|postage|posted|parcel\w*|packag\w*|transit|tracking|dispatch\w*|customs|await\w*|wait\w*|late|delay\w*|slow\w*|quick\w*|fast\w*|prompt\w*|speedy|on time)\b/i;

  /* ---- owner-pulled reviews, keyed by Judge.me review uuid ----
   * Hides the CARD only, exactly as PS_REVIEW_HIDDEN does in assets/ps-reviews.js, from
   * which this is copied. Judge.me still holds the review, so every count and average this
   * strip shows still includes it. Hiding it in the Judge.me admin as well is the only
   * thing that also corrects the count and the average. */
  var PS_REVIEW_HIDDEN = {
    // Modern lamp, Diana, 4 stars, "The brightness doesn't change, although the
    // description says it does." Owner removed 2026-08-10.
    '7a16e7ce-d071-4a4e-a4c2-227c6b058af7': 'modern-brightness-2026-08-10',
    // Original lamp, Lyubov, 5 stars, 2025-10-15. The text is fine; one of its three
    // photographs is a BRCOK branded box printed "Reduces allergic symptoms",
    // "Physically revitalizes", "Makes breathing easier". A rival's brand and three
    // medical claims. The claims gate above reads review TEXT and cannot read a
    // photograph, which is exactly how it got through at 66px. 2026-09-10.
    '99e1a59d-de63-49c7-ae44-7bbb6cb681ad': 'natural-rival-box-banned-claims-2026-09-10'
  };

  /* Copied verbatim from assets/ps-reviews.js. AliExpress-era imports carry no Judge.me
     slug, so their filenames map to our own re-hosted copies here.
     Source of truth: media-src/review-photos/manifest.json. */
  var PS_REHOST = {
    'A24850055887d4fe6b0f4de15b9a77dbah.jpg': 'https://cdn.shopify.com/s/files/1/0670/2625/6078/files/review-wall-robert-price-1.avif?v=1784429284',
    'A28dc295e829041e9b0da50415760a37ft.jpg': 'https://cdn.shopify.com/s/files/1/0670/2625/6078/files/review-diffuser-guadalupe-wintheiser-3.avif?v=1784429284',
    'A2c7cd1b6ddeb42e79e07f1f06efcee42R.jpg': 'https://cdn.shopify.com/s/files/1/0670/2625/6078/files/review-wall-alpha-schowalter-1.avif?v=1784429284',
    'A3577b4a9c7f2493586c0694c224f62afT.jpg': 'https://cdn.shopify.com/s/files/1/0670/2625/6078/files/review-wall-micheal-greenfelder-1.avif?v=1784429284',
    'A3cab71b8fdf447ca890201cd28d2adfdU.jpg': 'https://cdn.shopify.com/s/files/1/0670/2625/6078/files/review-scrub-roberto-pacocha-1.avif?v=1784429284',
    'A3db75f80310b40f69c508cf4900bf1f6j.jpg': 'https://cdn.shopify.com/s/files/1/0670/2625/6078/files/review-scrub-king-ratke-2.avif?v=1784429284',
    'A3e021c6a90f44b5a9ca22a6ea2b381f4z.jpg': 'https://cdn.shopify.com/s/files/1/0670/2625/6078/files/review-diffuser-reena-schulist-2.avif?v=1784429284',
    'A49a83b9b670046dd821eabc8d9823c4aG.jpg': 'https://cdn.shopify.com/s/files/1/0670/2625/6078/files/review-scrub-reed-mcglynn-1.avif?v=1784429284',
    'A52ee7a1cbdde4fd0ba95b2c48fd99a05O.jpg': 'https://cdn.shopify.com/s/files/1/0670/2625/6078/files/review-diffuser-guadalupe-wintheiser-2.avif?v=1784429284',
    'A68cfd99732a94067adb8fcfbf3543a53F.jpg': 'https://cdn.shopify.com/s/files/1/0670/2625/6078/files/review-scrub-ariel-turner-1.avif?v=1784429284',
    'A7effdeb34aa84ee48c07ec7ae8ab31e0W.jpg': 'https://cdn.shopify.com/s/files/1/0670/2625/6078/files/review-diffuser-guadalupe-wintheiser-1.avif?v=1784429284',
    'Aa76aff99fd7346db9473df8a66f7726ex.jpg': 'https://cdn.shopify.com/s/files/1/0670/2625/6078/files/review-wall-christian-moen-1.avif?v=1784429284',
    'Aac9175fbefbf45049223dd9a8b2ea834C.jpg': 'https://cdn.shopify.com/s/files/1/0670/2625/6078/files/review-scrub-ayesha-torphy-1.avif?v=1784429284',
    'Ad49f9b818e1f49e2bf9f275f1639a88aq.jpg': 'https://cdn.shopify.com/s/files/1/0670/2625/6078/files/review-scrub-junior-abshire-1.avif?v=1784429284',
    'Aeb8e9bc1c068417ebd4fc05cdc604b41k.jpg': 'https://cdn.shopify.com/s/files/1/0670/2625/6078/files/review-scrub-king-ratke-1.avif?v=1784429284',
    'Aebfc83ed4135450f8b70b85dc680dbe2r.jpg': 'https://cdn.shopify.com/s/files/1/0670/2625/6078/files/review-wall-micheal-greenfelder-2.avif?v=1784429284',
    'Af126ef5e9ea94e3b9728817f69d9360dY.jpg': 'https://cdn.shopify.com/s/files/1/0670/2625/6078/files/review-diffuser-reena-schulist-1.avif?v=1784429284'
  };

  function esc(s) { var d = document.createElement('div'); d.textContent = s == null ? '' : s; return d.innerHTML; }
  function normalize(s) { return (s || '').replace(/\s+/g, ' ').trim(); }
  function htmlToText(html) { var d = document.createElement('div'); d.innerHTML = html || ''; return normalize(d.textContent || ''); }

  /* Parsed off the string, never through new Date(): a bare "2025-10-15" parses as UTC
     midnight and then prints in the viewer's local zone, which prints the previous day for
     everyone west of Greenwich. Same implementation as assets/ps-reviews.js. */
  function fmtDate(ds) {
    var m = (ds || '').match(/(\d{4})-(\d{2})-(\d{2})/);
    return m ? MONTHS[+m[2] - 1] + ' ' + (+m[3]) + ', ' + m[1] : '';
  }

  /* OWNER RULING 2026-09-08: "do not rehost them on shopify and let judge.me host it."
     Judge.me's own image hosts pass through untouched. Everything we cannot place is
     DROPPED rather than returned, because the URLs that catches are ae-pic AliExpress and
     kwcdn Temu, which announce the supplier on the store's front page. A photo that
     silently disappears is a visible bug; a photo that silently leaks is not.
     Copied from assets/ps-reviews.js. */
  function rehost(u) {
    if (!u) return u;
    if (/^https:\/\/review-images\.judge(\.me|me\.com)\//.test(u)) return u;
    var m = /([A-Za-z0-9]+\.jpg)/.exec((u.split('?')[0].split('/').pop()) || '');
    if (m && PS_REHOST[m[1]]) return PS_REHOST[m[1]];
    return /^https:\/\/cdn\.shopify\.com\//.test(u) ? u : null;
  }
  function picThumb(p) { return rehost(!p ? null : (typeof p === 'string' ? p : (p.thumbnail || p.compact || p.original || p.huge || p.url))); }
  function picFull(p) { return rehost(!p ? null : (typeof p === 'string' ? p : (p.huge || p.original || p.compact || p.thumbnail || p.url))); }

  /* Judge.me serves review photographs with a width parameter, so a card can ask for the
     size it actually paints instead of taking the 1024 the API hands back for every slot.
     Anything without that parameter passes through untouched. */
  function picAt(u, w) {
    return u && /[?&]width=\d+/.test(u) ? u.replace(/([?&]width=)\d+/, '$1' + w) : u;
  }

  /* MEASURED on the rendered PRODUCT band (assets/ps-reviews.js) and reused unchanged,
     because this strip's grid is now that band's grid to the pixel: same 1080px cap, same
     1fr / two-up at 750 / three-up at 1050 columns, same .8rem and 1.1rem gaps, inside the
     same Horizon .section--page-width shell. Re-measure both if either grid moves. */
  var SZ_ONE = '(min-width: 1160px) 313px, (min-width: 1050px) calc((100vw - 115px)/3 - 36px), '
    + '(min-width: 750px) calc(50vw - 84px), calc(100vw - 68px)';
  var SZ_MANY = '(min-width: 1160px) 100px, (min-width: 1050px) calc(((100vw - 115px)/3 - 49px)/3), '
    + '(min-width: 750px) calc((50vw - 97px)/3), calc((100vw - 81px)/3)';

  /* Discrete five-glyph star row, the product card's own. A review's rating is a whole
     number, so this is exact. Copied from assets/ps-reviews.js. */
  function stars(n) {
    var s = '';
    for (var i = 1; i <= 5; i++) s += '<span class="ps-rev__star' + (i <= n ? ' is-on' : '') + '">★</span>';
    return s;
  }

  /* The AGGREGATE keeps this strip's own clipped meter rather than the card's five glyphs,
     because an average is fractional: 4.86 must not paint as a flat five, and rounding to
     the nearest whole star would do exactly that. width:max-content on .ps-hrev-stars is
     load-bearing for it; see the note in sections/ps-home-reviews.liquid. */
  function starsEl(value) {
    var v = Math.max(0, Math.min(5, Number(value) || 0));
    var wrap = document.createElement('span');
    wrap.className = 'ps-hrev-stars';
    wrap.style.setProperty('--ps-star-pct', (v / 5 * 100).toFixed(2) + '%');
    wrap.setAttribute('role', 'img');
    wrap.setAttribute('aria-label', v.toFixed(1) + ' out of 5 stars');

    var bg = document.createElement('span');
    bg.className = 'ps-hrev-stars__bg';
    bg.textContent = '★★★★★';
    var fg = document.createElement('span');
    fg.className = 'ps-hrev-stars__fg';
    fg.setAttribute('aria-hidden', 'true');
    fg.textContent = '★★★★★';

    wrap.appendChild(bg);
    wrap.appendChild(fg);
    return wrap;
  }

  /* One request per product: page 1 is its 30 newest reviews AND the whole-product totals.
     `number_of_reviews` / `average_rating` are the same two fields assets/ps-reviews.js
     reads for the PDP summary, so the front page and the product page cannot disagree.
     A product whose totals do not parse still contributes its CARDS but is left out of the
     aggregate entirely, so the headline is never computed from a partial denominator. */
  function fetchProduct(shop, product) {
    var url = 'https://api.judge.me/reviews/reviews_for_widget?platform=shopify&url=' + encodeURIComponent(shop) +
      '&shop_domain=' + encodeURIComponent(shop) +
      '&product_id=' + encodeURIComponent(product.id) + '&per_page=30&page=1';

    return fetch(url)
      .then(function (res) {
        if (!res.ok) throw new Error('judgeme ' + res.status);
        return res.json();
      })
      .then(function (j) {
        var total = Number(j && j.number_of_reviews) || 0;
        var avg = parseFloat(j && j.average_rating);
        var seen = {};
        // Judge.me exposes photo reviews from older pages through photo_gallery. Merge it
        // with the newest page so picture-first merchandising is genuine, not limited to
        // whichever photo reviews happened to be among the newest thirty.
        var sourceReviews = ((j && j.reviews) || []).concat((j && j.photo_gallery) || [])
          .filter(function (r) {
            var key = r.uuid || [r.reviewer_name, r.created_at, r.body_html || r.body].join('|');
            if (seen[key]) return false;
            seen[key] = true;
            return true;
          });
        return {
          total: total,
          avg: (total > 0 && isFinite(avg) && avg > 0) ? avg : null,
          reviews: sourceReviews.map(function (r) {
            var body = htmlToText(r.body_html || r.body);
            return {
              product: product,
              uuid: r.uuid || '',
              rating: Number(r.rating) || 0,
              created_at: r.created_at || '',
              reviewer: normalize(r.reviewer_name || r.reviewer_initial),
              verified: !!r.verified_buyer,
              body: body,
              text: normalize((r.title || '') + ' ' + body),
              pics: (r.pictures_urls || [])
            };
          })
        };
      })
      .catch(function () { return { total: 0, avg: null, reviews: [] }; });
  }

  /* Mirror of renderCard() in assets/ps-reviews.js. Read the file header before editing.
     The photographs are REAL <img loading="lazy">, not CSS backgrounds: a background on an
     element that is in the DOM downloads whether or not it is on screen, which is what put
     137 KB of thumbnails on the wire at first paint before (Errors CT), and an img can
     carry alt text where a background never could. */
  function renderCard(r, pictureFirst) {
    var rawName = (r.reviewer || '').trim() || 'Verified Buyer';
    var name = esc(rawName);
    // the initial is taken BEFORE escaping: the first character of "&amp;" is "&"
    var initial = esc((rawName.charAt(0) || '?').toUpperCase());
    var date = fmtDate(r.created_at);
    var rating = r.rating || 5;
    var href = esc(r.product.url);
    /* Every review on this store is imported, so verified_buyer is false on all of them
       and this chip renders nothing today. It exists so a genuinely verified review gets
       its badge, and so that nothing ever invents one (Errors CR). */
    var chip = r.verified ? '<span class="ps-rev__chip">Verified</span>' : '';

    var pics = r.pics.map(function (p) { return { t: picThumb(p), f: picFull(p) }; })
      .filter(function (x) { return x.t; }); // drop any photo we could not place (never leak AliExpress)

    /* HOMEPAGE ONLY: one real customer image keeps the picture-first carousel compact.
       Gated on pictureFirst, which is the section's data-picture-only attribute and is true
       only while request.page_type == 'index'. This same renderer draws the reviews band on
       /collections/all and /collections/salt-lamps, where a card has always shown every
       photograph it has: capping there would silently drop real customer photos, and the
       2x2 `is-four` shape a few lines below exists for exactly that case. */
    if (pictureFirst) pics = pics.slice(0, 1);

    var picsHtml = '';
    if (pics.length) {
      var one = pics.length === 1;
      // four across auto-fit columns is three and an orphan; 2x2 reads as a set
      var shape = one ? ' is-one' : (pics.length === 4 ? ' is-four' : '');
      picsHtml = '<div class="ps-rev__pics' + shape + '">' + pics.map(function (x) {
        var base = x.f || x.t;
        /* DIVERGENCE 2: a LINK to the product, where the product card opens a lightbox.
           This strip has no lightbox, and a <button> wired to nothing is a defect rather
           than a smaller feature. Sending the click to the product is also the only thing
           a homepage review photograph is actually for. */
        return '<a class="ps-rev__pic" href="' + href + '"><img class="ps-rev__ph" src="'
          + picAt(base, one ? 640 : 320) + '" srcset="' + picAt(base, 320) + ' 320w, '
          + picAt(base, 480) + ' 480w, ' + picAt(base, 640) + ' 640w, '
          + picAt(base, 900) + ' 900w" sizes="'
          + (one ? SZ_ONE : SZ_MANY) + '" alt="Customer photo from a review by ' + name
          + '" loading="lazy" decoding="async"></a>';
      }).join('') + '</div>';
    }

    /* DIVERGENCE 1: TEXT, never HTML. The product card inserts Judge.me's body_html; this
       strip has escaped its bodies since it was written, which also stops user-supplied
       content injecting markup onto the front page. Visually identical for a real review. */
    var bodyHtml = r.body ? '<div class="ps-rev__body">' + esc(r.body) + '</div>' : '';

    /* DIVERGENCE 4: name the product. The product page knows what is being reviewed; this
       strip mixes products, so an unlabelled lamp review under a store-wide heading would
       read as a review of whatever the shopper looks at next. */
    var forHtml = '<p class="ps-rev__for">on <a href="' + href + '">' + esc(r.product.name) + '</a></p>';

    /* DIVERGENCE 3: no review video. PS_REVIEW_VIDEOS on the product page renders a
       <video preload="metadata">, which puts bytes on the wire for a three-card teaser. */
    var contentHtml = '<div class="ps-rev__top">'
      + '<span class="ps-rev__av" aria-hidden="true">' + initial + '</span>'
      + '<span class="ps-rev__id"><b class="ps-rev__name">' + name + '</b>'
      + '<span class="ps-rev__meta">' + date + '</span></span>' + chip
      + '</div>'
      + '<span class="ps-rev__stars" role="img" aria-label="Rated ' + rating + ' out of 5">'
      + stars(rating) + '</span>'
      + bodyHtml
      + forHtml;

    if (pictureFirst) {
      return '<div class="ps-rev">' + picsHtml + '<div class="ps-rev__content">' + contentHtml + '</div></div>';
    }

    return '<div class="ps-rev">'
      + '<div class="ps-rev__top">'
      + '<span class="ps-rev__av" aria-hidden="true">' + initial + '</span>'
      + '<span class="ps-rev__id"><b class="ps-rev__name">' + name + '</b>'
      + '<span class="ps-rev__meta">' + date + '</span></span>' + chip
      + '</div>'
      + '<span class="ps-rev__stars" role="img" aria-label="Rated ' + rating + ' out of 5">'
      + stars(rating) + '</span>'
      + bodyHtml
      + picsHtml
      + forHtml
      + '</div>';
  }

  function renderAggregate(node, count, avg) {
    var row = document.createElement('div');
    row.className = 'ps-hrev-agg__row';
    row.appendChild(starsEl(avg));
    var val = document.createElement('span');
    val.className = 'ps-hrev-agg__val';
    val.textContent = avg.toFixed(1) + ' out of 5';
    row.appendChild(val);

    var cnt = document.createElement('p');
    cnt.className = 'ps-hrev-agg__count';
    cnt.appendChild(document.createTextNode('Based on '));
    var countStrong = document.createElement('strong');
    countStrong.textContent = count.toLocaleString() + (count === 1 ? ' review' : ' reviews');
    cnt.appendChild(countStrong);

    node.textContent = '';
    node.appendChild(row);
    node.appendChild(cnt);
    node.hidden = false;
  }

  function renderHeroAggregate(count, avg) {
    var node = document.querySelector('[data-ps-hp2-hero-reviews]');
    if (!node || count < 1 || !isFinite(avg)) return;
    var rating = node.querySelector('[data-ps-hp2-hero-rating]');
    var reviews = node.querySelector('[data-ps-hp2-hero-count]');
    if (rating) rating.textContent = avg.toFixed(1) + '/5';
    if (reviews) {
      var heroCountLead = window.matchMedia && window.matchMedia('(max-width: 749px)').matches ? '· ' : 'from ';
      reviews.textContent = heroCountLead + count.toLocaleString() + (count === 1 ? ' review' : ' reviews');
    }
    node.querySelectorAll('[hidden]').forEach(function (item) { item.hidden = false; });
    node.setAttribute('aria-label', avg.toFixed(1) + ' out of 5 from ' + count.toLocaleString() + (count === 1 ? ' review' : ' reviews'));
    node.setAttribute('aria-busy', 'false');
    node.classList.add('is-ready');
  }

  function featureScore(review) {
    var score = 0;
    if (review.pics.some(function (pic) { return !!picThumb(pic); })) score += 240;
    if (review.rating >= 5) score += 24;
    else if (review.rating >= 4) score += 12;
    if (FEATURE_TERMS.test(review.text)) score += 70;
    if (review.body.length >= 90 && review.body.length <= 360) score += 24;
    else if (review.body.length <= 520) score += 10;
    return score;
  }

  function hasUsablePicture(review) {
    return review.pics.some(function (pic) { return !!picThumb(pic); });
  }

  function initReviewCarousel(listNode, navNode) {
    if (!listNode || !navNode) return;
    var cards = listNode.querySelectorAll('.ps-rev');
    if (cards.length < 2) return;

    var prev = navNode.querySelector('[data-ps-review-prev]');
    var next = navNode.querySelector('[data-ps-review-next]');
    var progress = navNode.querySelector('[data-ps-review-progress]');
    var status = navNode.querySelector('[data-ps-review-status]');
    var ticking = false;
    if (!prev || !next || !progress || !status) return;

    function update() {
      var maxScroll = Math.max(0, listNode.scrollWidth - listNode.clientWidth);
      var totalPages = Math.max(1, Math.ceil(listNode.scrollWidth / listNode.clientWidth));
      var ratio = maxScroll ? listNode.scrollLeft / maxScroll : 0;
      var currentPage = Math.min(totalPages, Math.max(1, Math.round(ratio * (totalPages - 1)) + 1));
      prev.disabled = listNode.scrollLeft <= 2;
      next.disabled = listNode.scrollLeft >= maxScroll - 2;
      progress.style.setProperty('--ps-review-progress', String(currentPage / totalPages));
      status.textContent = currentPage + ' / ' + totalPages;
      ticking = false;
    }

    function requestUpdate() {
      if (ticking) return;
      ticking = true;
      window.requestAnimationFrame(update);
    }

    function move(direction) {
      var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      listNode.scrollBy({ left: direction * listNode.clientWidth, behavior: reduceMotion ? 'auto' : 'smooth' });
    }

    prev.addEventListener('click', function () { move(-1); });
    next.addEventListener('click', function () { move(1); });
    listNode.addEventListener('scroll', requestUpdate, { passive: true });
    window.addEventListener('resize', requestUpdate, { passive: true });
    navNode.hidden = false;
    listNode.setAttribute('tabindex', '0');
    listNode.setAttribute('aria-label', 'Customer photo reviews');
    update();
  }

  function init() {
    var root = document.getElementById(ROOT_ID);
    if (!root) return;

    var products;
    try { products = JSON.parse(root.getAttribute('data-products') || '[]'); } catch (e) { products = []; }
    if (!products.length) return;

    var max = parseInt(root.getAttribute('data-max-cards'), 10) || 3;
    var initial = parseInt(root.getAttribute('data-initial-cards'), 10) || 3;
    var diverse = root.getAttribute('data-diverse-products') === 'true';
    var curated = root.getAttribute('data-curated-selection') === 'true';
    var pictureOnly = root.getAttribute('data-picture-only') === 'true';
    var carousel = root.getAttribute('data-review-carousel') === 'true';
    var aggNode = root.querySelector('[data-ps-agg]');
    var listNode = root.querySelector('[data-ps-list]');
    var moreButton = root.querySelector('[data-ps-review-more]');
    var navNode = root.querySelector('[data-ps-review-nav]');
    if (!aggNode || !listNode) return;

    var shop = (window.Shopify && window.Shopify.shop) || location.hostname;

    Promise.all(products.map(function (p) { return fetchProduct(shop, p); }))
      .then(function (sets) {
        // Aggregate from the API's own per-product totals, never from the fetched sample.
        var count = 0, weighted = 0;
        sets.forEach(function (s) {
          if (s.avg === null || !s.total) return;
          count += s.total;
          weighted += s.avg * s.total;
        });

        var pool = sets.reduce(function (a, s) { return a.concat(s.reviews); }, []);
        var featurable = pool.filter(function (r) {
          if (PS_REVIEW_HIDDEN[r.uuid]) return false;   // owner-pulled, store-wide
          if (BANNED_CLAIM.test(r.text)) return false;  // claims matrix
          if (!pictureOnly && NO_DELIVERY.test(r.text)) return false; // curated placements avoid delivery promises
          if (pictureOnly && !hasUsablePicture(r)) return false;
          if (!pictureOnly && r.rating < 4) return false;
          if (!pictureOnly && r.body.length < MIN_FEATURE_BODY) return false;
          // Text-less imports whose body just repeats the product title.
          if (!pictureOnly && r.body.toLowerCase() === (r.product.title || '').toLowerCase()) return false;
          return true;
        });

        featurable.sort(function (a, b) {
          if (pictureOnly) return (b.created_at || '').localeCompare(a.created_at || '');
          if (curated) return featureScore(b) - featureScore(a) || (b.created_at || '').localeCompare(a.created_at || '');
          return (b.created_at || '').localeCompare(a.created_at || '');
        });

        var cards;
        if (pictureOnly) {
          // Homepage merchandising is intentionally strict: the latest genuine photo
          // reviews win, regardless of product. The product label on every card keeps
          // the source transparent without disturbing the chronological order.
          cards = featurable.slice(0, max);
        } else if (diverse) {
          cards = [];
          var seenReviews = {};
          if (curated) {
            // Product-list order is editorial and editable in Theme Editor. Take the most
            // useful real review from each listed product before any product repeats.
            products.forEach(function (product) {
              if (cards.length >= max) return;
              var review = featurable.find(function (candidate) {
                return candidate.product.id === product.id && !seenReviews[candidate.uuid];
              });
              if (!review) return;
              seenReviews[review.uuid] = true;
              cards.push(review);
            });
          } else {
            var seenProducts = {};
            featurable.forEach(function (review) {
              if (cards.length >= max || seenProducts[review.product.id]) return;
              seenProducts[review.product.id] = true;
              seenReviews[review.uuid] = true;
              cards.push(review);
            });
          }
          if (cards.length < max) {
            featurable.forEach(function (review) {
              if (cards.length >= max || seenReviews[review.uuid]) return;
              seenReviews[review.uuid] = true;
              cards.push(review);
            });
          }
        } else {
          cards = featurable.slice(0, max);
        }
        if (curated && !pictureOnly) {
          // Preserve the diverse, one-review-per-product selection, then place genuine
          // customer photography first without changing review content or live totals.
          cards.sort(function (a, b) {
            return Number(hasUsablePicture(b)) - Number(hasUsablePicture(a));
          });
        }
        // Render NOTHING rather than an aggregate hovering over an empty list.
        if (!cards.length) return;

        listNode.innerHTML = cards.map(function (review, index) {
          var html = renderCard(review, pictureOnly);
          if (!carousel && index >= initial) html = html.replace('class="ps-rev"', 'class="ps-rev ps-rev--deferred"');
          return html;
        }).join('');
        if (!carousel && moreButton && cards.length > initial) {
          moreButton.hidden = false;
          moreButton.addEventListener('click', function () {
            listNode.querySelectorAll('.ps-rev--deferred').forEach(function (card) {
              card.classList.remove('ps-rev--deferred');
            });
            moreButton.hidden = true;
          }, { once: true });
        }
        if (count > 0) {
          renderAggregate(aggNode, count, weighted / count);
          renderHeroAggregate(count, weighted / count);
        }
        root.classList.add('ps-hrev--ready');
        if (carousel) {
          window.requestAnimationFrame(function () {
            initReviewCarousel(listNode, navNode);
          });
        }
      })
      .catch(function () {
        /* leave the band hidden rather than show broken chrome */
      });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
